import React, { Fragment } from 'react'
import { connect } from 'react-redux'
import { func, string } from 'prop-types'
import { downloadFile } from '../../../../store/Actions/Downloads'
import { toggleDownloads } from '../../../../store/Actions/UiActions'
import Csv from './Csv'
import GeoJson from './GeoJson'

const DownloadTypes = ({ theme, toggleDownloads }) => (
  <Fragment>
    <GeoJson theme={theme} download={downloadFile} toggle={toggleDownloads} />
    <Csv theme={theme} download={downloadFile} toggle={toggleDownloads} />
  </Fragment>
)

DownloadTypes.propTypes = {
  theme: string.isRequired,
  toggleDownloads: func.isRequired,
}

const mapDispatchToProps = dispatch => ({
  toggleDownloads: value => dispatch(toggleDownloads(value)),
})

export default connect(null, mapDispatchToProps)(DownloadTypes)



// WEBPACK FOOTER //
// ./src/components/Elements/SearchContent/Downloads/DownloadTypes.jsx